import {SignUpComponent} from "./SignUpComponent.js";
import {addJoinUseInttId, getEmail} from "../store.js";


export class InviterList extends SignUpComponent {

    template() {
        const {inviterList = []} = this.$props;
        return inviterList.map((inviterInfo) => this.getInviterItemTemplate(inviterInfo)).join(" ")
    }

    getInviterItemTemplate(inviterInfo) {
        const {
            FLNM = '',
            PRFL_PHTG = '',
            USER_ID = '',
            USE_INTT_ID,
            USE_INTT_NM = '',
        } = inviterInfo;
        const companyInfoContents = !Mutil.empty(USE_INTT_NM) ? `<dd>${USE_INTT_NM}</dd>` : ''
        return `
                 <button class="js-inviter-li" use-intt-id="${USE_INTT_ID}">
                        <i class="profile">
                            <img src="${PRFL_PHTG}" alt="" onerror="this.src='/flow-renewal/assets/images/profile-default.png'">
                        </i>
                        <div>
                            <em>${i18next.t(login.usingBy,{val : Mutil.n2v(FLNM)})}</em>
                            <span>${companyInfoContents}</span>
                        </div>
                        <i>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                                <path d="M6.75 5L11.25 9.5L6.75 14" stroke="#999999" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </i>
                 </button>
         `
    }

    setEvent() {
        const {
            moveCompanyInfoPage = Mutil.noop
        } = this.$props;
        this.addEvent("click.stop", ".js-inviter-li", (e) => {
            const $inviterItems = $(e.target).closest(".js-inviter-li");
            const joinUseInttId = $inviterItems.attr("use-intt-id");
            addJoinUseInttId(joinUseInttId);
            moveCompanyInfoPage();
        })
    }
}